import { Box, Grid } from "@mui/material";
import Modal from "@mui/material/Modal";
import SoftSelect from "components/SoftSelect";
import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../../../../../../App";
import { getSessionCloseDetails } from "../../../../../../config/Services";
import Navbar from "../../../../posnavbar/Navbar";
import StyledButton from "../../../all-products/components/custom/StyledButton";
import SliderTabManager from "../../../all-products/components/sliderModalManger";
import { addmanagerpin, addpin } from "../../../all-products/redux/Actions/SessionActions";
import "./index.css";
import { getFromLocalStorage } from "../../../../../../utils/localStorageHelpers";
import PosCustomIcon from "../../../../../../customComponents/PosCustomIcon/PosCustomIcon";
import { FireIcon } from "@heroicons/react/20/solid";
import CurrentSessionCard from "./components/CurrentSessionCard";
import dishIcon from "../../../../../../assets/images/dish.png";
import percentageIcon from "../../../../../../assets/images/percentage.png";
import returnsIcon from "../../../../../../assets/images/returns.png";
import rupeesIcon from "../../../../../../assets/images/rupees-icon.png";
import cashV2 from "../../../../../../assets/images/cashV2.png";
import { PosCustomButton } from "../../../../../../customComponents/PosCustomButton/PosCustomButton";
import { ArrowLongRightIcon } from "@heroicons/react/24/outline";
import ProgressBar from "../../../../../../customComponents/PosCustomProgressBar/PosCustomProgressBar";

export const ClosingV2 = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [diffAmount, setDiffAmount] = useState(0);
  const [sessionSummary, setSessionSummary] = useState(null);
  const [comment, setComment] = useState("");
  const [commentI, setCommentI] = useState("");
  const [sessionAdvance, setSessionAdvance] = useState("");
  const { totalAmountDen, setTotalamountDen } = useContext(UserContext);
  const { denoArr, setDenoArr } = useContext(UserContext);
  const sessionId = localStorage.getItem("sessionId");
  const licenseId = localStorage.getItem("licenseId");
  const paymentMethods = localStorage.getItem("paymentMethods");
  const hasSodexo = paymentMethods?.includes("SODEXO");
  const isAmountGreater = sessionSummary?.cashHandOver >= totalAmountDen;
  const { uidx } = JSON.parse(localStorage.getItem("retailUserDetails"));
  const locId = localStorage.getItem("locId");

  const retailType = localStorage.getItem("retailType");

  const allowCreditPayment =
    getFromLocalStorage("appConfig")?.enabledFeatures?.ALLOW_CREDIT_PAYMENT;

  const reasonsArr = [
    { value: "Incorrect change paid", label: "Incorrect change paid" },
    {
      value: "Overpaid to customer due to insufficient change",
      label: "Overpaid to customer due to insufficient change",
    },
    { value: "Customer insufficent funds", label: "Customer insufficent funds" },
    { value: "others", label: "others" },
  ];

  const handleCancel = () => {
    if (pathname == "/session-page/closing") {
      // navigate("/session-page/session-listing");
      navigate(-1);
    } else {
      navigate("/session-page/opening");
    }
  };

  useEffect(() => {
    getSessionCloseDetails(locId, licenseId, sessionId).then((res) => {
      setSessionAdvance(res?.data?.data?.sessionData);
      setSessionSummary(res?.data?.data?.sessionData?.sessionSalesData);
    });
  }, []);

  useEffect(() => {
    if (sessionSummary && totalAmountDen) {
      setDiffAmount(sessionSummary?.cashHandOver - totalAmountDen);
    }
  }, [totalAmountDen, sessionSummary]);

  const handleStart = () => {
    setOpen(true);
    dispatch(addpin(""));
    dispatch(addmanagerpin(""));
  };

  useEffect(() => {
    if (open) return;
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && totalAmountDen) {
        handleStart();
      } else if (e.key === "Escape") {
        handleCancel();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [totalAmountDen, open]);
  return (
    <Navbar pageTitle={"Sessions"}>
      <Box className="new-current-session-wrapper-box">
        {/* progress bar and button section */}
        <section className="deno-top-container-section">
          {/* progressbar and label */}
          <div className="progressbar-container-div">
            {/* progressbar label part  */}
            <div className="progressbar-container-label-div">
              <p className="progressbar-label-p">Closing Sessions</p>
            </div>

            {/* progress bar section */}
            <div className="progress-bar-container">
              <ProgressBar percentage={85} progressBarHeight={"10px"} />
            </div>
          </div>

          {/* cancel and save btn */}
          <div className="cancel-save-btn-div">
            <PosCustomButton
              title="Back"
              p="8px 12px"
              height="40px"
              onClickFunction={handleCancel}
            />

            <PosCustomButton
              title="Print"
              p="8px 12px"
              height="40px"
              variant="blue-s"
              transparent={true}
              // onClickFunction={}
            />

            <PosCustomButton
              title="Next"
              p="8px 12px"
              height="40px"
              variant="blue-d"
              iconOnRight={<ArrowLongRightIcon height={"20px"} width={"20px"} />}
              onClickFunction={handleStart}
            />
          </div>
        </section>
        {/* <p className="new-current-session-heading">Close Session</p> */}
        <div className="newCurrentSessionDetailsContainer">
          <div className="newSessionDetailsHeading">
            <div className="newCurrentSessionDetailsStyle">
              {/* <div className="newCurrentSessionDetailsSideStyle"></div> */}
              <div className="session-details-text-div">Session Details</div>
            </div>
            {/* <PosCustomIcon
              icon={<FireIcon />}
              color="var(--blue-b0)"
              height={"16px"}
              width={"16px"}
            /> */}
          </div>

          <div className="newSessionCardContainer">
            <CurrentSessionCard
              icon={dishIcon}
              title={"Total orders processed"}
              value={sessionSummary?.totalOrders || 0}
            />
            {retailType === "RESTAURANT" && (
              <CurrentSessionCard
                icon={dishIcon}
                title={"Total online orders processed"}
                value={sessionSummary?.onlineOrders || 0}
              />
            )}
            <CurrentSessionCard
              icon={percentageIcon}
              title={"Total order value"}
              value={sessionSummary?.totalOrdersValue || 0}
            />
            {retailType === "RESTAURANT" && (
              <CurrentSessionCard
                icon={percentageIcon}
                title={"Total online orders value"}
                value={sessionSummary?.onlineOrdersValue || 0}
              />
            )}
            <CurrentSessionCard
              icon={returnsIcon}
              title={"Return & refunds"}
              value={sessionSummary?.returns || 0}
            />
            <CurrentSessionCard
              icon={rupeesIcon}
              title={"Return & refunds value"}
              value={sessionSummary?.cashRefunds || 0}
            />
            <CurrentSessionCard
              icon={cashV2}
              title={"Session cash advance"}
              value={sessionAdvance?.sessionCashAdvance || 0}
            />
          </div>
        </div>

        <div className="newSessionSummaryGrid">
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <table className="new-session-summary-table">
                <tbody>
                  <tr>
                    <th colSpan={2}>Return/Refunds</th>
                  </tr>

                  <tr>
                    <td>Total upi payment recieved</td>
                    <td>
                      {`\u20b9`} {sessionSummary?.upiPayments || 0}
                    </td>
                  </tr>

                  <tr>
                    <td>Total card payment recieved</td>
                    <td>
                      {`\u20b9`} {sessionSummary?.cardPayments || 0}
                    </td>
                  </tr>

                  {hasSodexo && (
                    <tr>
                      <td>Total sodexo payment recieved</td>
                      <td>
                        {`\u20b9`} {sessionSummary?.sodexoPayments || 0}
                      </td>
                    </tr>
                  )}

                  <tr>
                    <td>Total</td>
                    <td>
                      {`\u20b9`}{" "}
                      {Math.round(
                        Number(sessionSummary?.cardPayments) +
                          Number(sessionSummary?.upiPayments) +
                          Number(sessionSummary?.sodexoPayments)
                      ) || 0}
                    </td>
                  </tr>

                  <tr>
                    <td>Difference against actual orders (Cash refunds)</td>
                    <td>
                      {`\u20b9`} {sessionSummary?.cashRefunds || 0}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Grid>

            <Grid item xs={12} md={6}>
              <table className="new-session-summary-table">
                <tbody>
                  <tr>
                    <th colSpan={2}>Cashier settlements</th>
                  </tr>

                  <tr>
                    <td>Session cash advance</td>
                    <td>
                      {`\u20b9`} {sessionAdvance?.sessionCashAdvance || 0}
                    </td>
                  </tr>

                  <tr>
                    <td>
                      Cash order value <b>-</b> returns/refunds difference
                    </td>
                    <td>
                      {`\u20b9`} {sessionSummary?.cashAfterAdjustment || 0}
                    </td>
                  </tr>

                  <tr>
                    <td>Total cash</td>
                    <td>
                      {`\u20b9`} {sessionSummary?.cashHandOver || 0}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Grid>
          </Grid>
        </div>

        <div className="newSessionSummaryGrid">
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <table className="new-session-summary-table">
                <tbody>
                  <tr>
                    <th colSpan={2}>Payment Mode</th>
                  </tr>

                  <tr>
                    <td>UPI</td>
                    <td>
                      {`\u20b9`}{" "}
                      {(sessionSummary?.upiPayments ?? 0) +
                        (sessionSummary?.creditUpiSettlements ?? 0)}
                    </td>
                  </tr>

                  <tr>
                    <td>Card</td>
                    <td>
                      {`\u20b9`}
                      {(sessionSummary?.cardPayments ?? 0) +
                        (sessionSummary?.creditCardSettlementsValue ?? 0)}
                    </td>
                  </tr>

                  {hasSodexo && (
                    <>
                      <td>Sodexo</td>
                      <td>
                        {`\u20b9`} {sessionSummary?.sodexoPayments || 0}
                        {(sessionSummary?.sodexoPayments ?? 0) +
                          (sessionSummary?.creditSodexoOrders ?? 0)}
                      </td>
                    </>
                  )}

                  <tr>
                    <td>Others</td>
                    <td>
                      {`\u20b9`} {sessionSummary?.otherOrdersValue || 0}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Grid>

            <Grid item xs={12} md={6}>
              <table className="new-session-summary-table">
                <tbody>
                  <tr>
                    <th colSpan={2}>Cash</th>
                  </tr>

                  <tr>
                    <td>Cash in counter</td>
                    <td>
                      {`\u20b9`} {sessionSummary?.cashHandOver}
                    </td>
                  </tr>

                  <tr>
                    <td>Cash recieved</td>
                    <td>
                      {`\u20b9`} {totalAmountDen}
                    </td>
                  </tr>

                  <tr>
                    <td>Discrepancy Amount</td>
                    <td
                      className={
                        isAmountGreater ? "discrepancyAmountMinus" : "discrepancyAmountPlus"
                      }
                    >
                      {isAmountGreater ? "-" : "+"} {`\u20b9`}{" "}
                      {!totalAmountDen
                        ? 0
                        : Math.abs(
                            Math.round(
                              Number(sessionSummary?.cashHandOver) - Number(totalAmountDen)
                            )
                          )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Grid>
          </Grid>
        </div>

        {diffAmount === 0 ? null : (
          <h3 className="heading-wrapper-text-new">Reason for amount discrepancy</h3>
        )}

        {diffAmount === 0 ? null : (
          <Grid container spacing={0}>
            <Grid item xs={12} md={12} xl={6} className="order-wrapper-detail-box">
              <SoftSelect
                className="soft-closing-wrapper-select"
                options={reasonsArr}
                onChange={(e) => setComment(e?.value)}
              />
            </Grid>
            {comment === "others" ? (
              <Grid item xs={12} md={12} xl={6} className="order-wrapper-detail-box">
                <h5>Comment</h5>
                <input
                  type="text"
                  className="order-wrapper-detail-box-input"
                  onChange={(e) => setCommentI(e.target.value)}
                />
              </Grid>
            ) : null}
          </Grid>
        )}

        {/* <div className="currentSessionActionButtonContainer">
          <PosCustomButton
            title="Cancel"
            variant="red-transparent"
            radius="4px"
            p="12px 16px"
            onClickFunction={handleCancel}
            width="50%"
          />
          <PosCustomButton
            title="Proceed"
            variant="blue-d"
            radius="4px"
            p="12px 16px"
            onClickFunction={handleStart}
            width="100%"
          />
        </div> */}

        <Modal
          open={open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="modal-popup"
        >
          <SliderTabManager
            setOpen={setOpen}
            totalAmountDen={totalAmountDen}
            comment={comment}
            commentI={commentI}
            denoArr={denoArr}
            sessionData={sessionAdvance}
          />
        </Modal>
      </Box>
    </Navbar>
  );
};
